function isEmpty(ob) {
  for (const i in ob) {
    return false
  }
  return true
}

export default isEmpty
